import { render } from "./particles.vue?vue&type=template&id=03d01b72&scoped=true"
import script from "./particles.vue?vue&type=script&lang=js"
export * from "./particles.vue?vue&type=script&lang=js"

import "./particles.vue?vue&type=style&index=0&id=03d01b72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d01b72"]])

export default __exports__